import axios from 'axios'
import config from '../config'

export function relaycfmInit() {
    return {
        type: 'RELAYCFM_INIT'
    }
}

export function relaycfmSetRelayRes(res) {
    return {
        type: 'RELAYCFM_SET_RELAY_RES',
        payload: res
    }
}

export function relaycfmShareInit (payload) {
    return {
        type: 'UPDATE_SHARE_DATA',
        payload,
    }
}

export function relaycfmSetFetchRes(payload) {
    return {
        type: 'RELAYCFM_SET_FETCH_RES',
        payload,
    }
}

export function relaycfmSetIsPaySuccess(payload) {
    return {
        type: 'RELAYCFM_SET_IS_PAY_SUCCESS',
        payload,
    }
}

export function relaycfmFetchLecture(id) {
    return dispatch => {
        dispatch(relaycfmSetPending(true))
        return axios.get(`/api/relay/lecture/${id}/info`)
            .then(res => {
                dispatch(relaycfmSetPending(false))
                if (res.data.code !== 0) {
                    return dispatch(relaycfmSetFetchRes(res.data))
                }
                dispatch(relaycfmSetLecture(res.data.data))
            })
    }
}

export function relaycfmPostRelayLecture(id, type) {
    if (type) {
        return dispatch => {
            axios.post(`/api/relay/lecture/${id}/relay?is_from_marcket=1`)
                .then(res => dispatch(relaycfmSetRelayRes(res.data)))
        }
    }
    return dispatch => {
        axios.post(`/api/relay/lecture/${id}/relay`)
            .then(res => dispatch(relaycfmSetRelayRes(res.data)))
    }
}

export function relaycfmSetPending(boolean) {
    return {
        type: 'RELAYCFM_SET_PENDING',
        payload: boolean,
    }
}

export function relaycfmSetLecture(lecture) {
    return {
        type: 'RELAYCFM_SET_LECTURE',
        payload: lecture
    }
}

export function relaycfmSetPaySuccessRes(payload) {
    return {
        type: 'RELAYCFM_SET_PAY_SUCCESS_RES',
        payload,
    }
}

export function relaycfmPayLecture(lectureId) {
    return dispatch => {
        dispatch({
            type: 'PAY_LECTURE',
            payload: {
                params: {
                    product: 'relay',
                    lecture_id: lectureId
                },
                success: (data) => {
                    axios.post(`/api/relay/lecture/${lectureId}/check`)
                        .then(res => {
                            if (res.data.code === 5) {
                                dispatch(relaycfmSetIsPaySuccess(true))
                                dispatch(relaycfmSetPaySuccessRes({
                                    type: 'lecture',
                                    id: res.data.data.lecture_id
                                }))
                            }
                        })
                }
            }
        })
    }
}



// channel

export function relaycfmPostRelayChannel(id, type) {
    if (type) {
        return dispatch => {
            axios.post(`/api/relay/channel/${id}/relay?is_from_marcket=1`)
                .then(res => dispatch(relaycfmSetRelayRes(res.data)))
        }
    }
    return dispatch => {
        axios.post(`/api/relay/channel/${id}/relay`)
            .then(res => dispatch(relaycfmSetRelayRes(res.data)))
    }
}

export function relaycfmFetchChannel(id) {
    return dispatch => {
        dispatch(relaycfmSetPending(true))
        return axios.get(`/api/relay/channel/${id}/info`)
            .then(res => {
                dispatch(relaycfmSetPending(false))
                if (res.data.code !== 0) {
                    return dispatch(relaycfmSetFetchRes(res.data))
                }
                dispatch(relaycfmSetChannel(res.data.data))
            })
    }
}

export function relaycfmSetChannel(channel) {
    return {
        type: 'RELAYCFM_SET_CHANNEL',
        payload: channel,
    }
}


export function relaycfmPayChannel(channelId, channelType) {
    return dispatch => {
        dispatch({
            type: 'PAY_CHANNEL',
            payload: {
                params: {
                    product: 'relay_channel',
                    channel_id: channelId,
                },
                success: () => {
                    axios.post(`/api/relay/channel/${channelId}/check`)
                        .then(res => {
                            if (res.data.code === 5) {
                                dispatch(relaycfmSetIsPaySuccess(true))
                                dispatch(relaycfmSetPaySuccessRes({
                                    type: 'channel',
                                    id: res.data.data.channel_id
                                }))
                            }
                        })
                }
            }
        })
    }
}






// WEBPACK FOOTER //
// ./src/actions/relayConfirm.js